import React from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { change, getFormValues } from 'redux-form'
import { formName } from '../thunks/constants'
import State from '../states/State'
import useStyles from '../styles/styles'
import {
  Grid
  , Paper
  , FormHelperText
  , FormControl
  , Divider
  , Typography
  , Button
  , MenuItem
  , Select
  , TextField
  // , FormControlLabel
  // , Switch
  , Tooltip
} from '@material-ui/core'
import ErrorIcon from '@material-ui/icons/Error'

import dialogSlice from '../states/dialog/slice'
import shellSlice from '../states/shell/slice'
import { installOpt } from '../fields/customer/installationField'
import PeMoreInfo from './PeMoreInfo'

const defaultItem = {
  product: '',
  qty: 1,
  installations: {},
  extras: {}
}

type PeProductItemProps = {
  readonly item: any;
  readonly num: any;
  readonly updateItemProd: any;
  readonly applyPrevUnit: any;
  readonly lastItem: any;
  readonly peInstall: boolean;
}

const PeProductItem: React.FC<PeProductItemProps> = ({ num, item, updateItemProd, applyPrevUnit, lastItem, peInstall }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { installations, extras } = item;
  const state = useSelector((state: State) => ({
    daikins: state.shell.productData?.daikins,
    isAuth: state.shell.isAuth,
  }));
  const { dk_main } = state.daikins;
  const isAuth = state.isAuth;

  const [product, setProduct] = React.useState(item.product);
  const [qty, setQty] = React.useState(item.qty);
  // const [wifi, setWifi] = React.useState(false);
  const [error, setError] = React.useState(true);

  const handleProdSelect = (event: any) => {
    setProduct(event.target.value);
    if (!product) setError(false);
  }

  const handleQtyChange = (event: any) => {
    setQty(parseInt(event.target.value));
  }

  // const handleWifiChange = (event: any) => {
  //   console.log(event);
  //   setWifi(prev => !prev);
  // }

  const handleEditClick = () => {
    dispatch(shellSlice.actions.updateTmp({ num, item }));
    dispatch(dialogSlice.actions.updateCrudDialog('installation'));
  }

  const handleApplyClick = () => {
    applyPrevUnit(num);
  }

  const renderLabelByValue = (prop: string, value: string) => {
    let result = "";
    if (!value) {
      return result;
    }
    switch (prop) {
      case 'standard_install':
      case 'external_wall':
      case 'rcd':
      case 'vertically':
      case 'same_wall':
        result = installOpt.yes_no.filter(word => word.value === value)[0].label;
        break;
      case 'brick_type':
        result = installOpt.brick_type.filter(word => word.value === value)[0].label;
        break;
      case 'storey_type':
        result = installOpt.storey_type.filter(word => word.value === value)[0].label;
        break;
      case 'outdoor':
        result = installOpt.outdoor.filter(word => word.value === value)[0].label;
        break;
      case 'circuit':
        result = installOpt.circuit.filter(word => word.value === value)[0].label;
        break;
      default: result = ''; break;
    }
    return result;
  }

  React.useEffect(() => {
    updateItemProd(num, item, product, qty);
    // eslint-disable-next-line
  }, [product, qty]);

  return <Grid item sm={6}>
      <Paper variant="outlined" style={{ padding: 10, borderWidth: '5px' }}>
        <Typography variant='h4' align='center' color='primary' style={{ fontFamily: 'Oswald', paddingBottom: 5 }}>Unit {num}</Typography>
        <Divider />
        <Grid container spacing={2} style={{ marginBottom: 10 }}>
          <Grid item xs={12} sm={9}>
            <div style={{ display: 'flex', 
              justifyContent: 'space-between', 
              fontSize: '13px', 
              color: '#9F9F9F', 
              alignItems: 'center',
              marginRight: '10px' }}>
              <p className={classes.PePrdChoice_text}>Product:</p>
              {/* <FormControlLabel
                control={<Switch color="primary" checked={wifi} onChange={handleWifiChange} size="small" />}
                label="Use Wifi"
                labelPlacement="start"
              /> */}
            </div>
            <FormControl variant="outlined" fullWidth error={error}>
              <Select onChange={handleProdSelect} value={product}>
                {dk_main.map((option: any, index: number) => {
                  return (
                    <MenuItem key={index} value={option.part_number} style={{ padding: 10, borderTop: '1px solid #f0f0f0' }}>
                      <Tooltip title={option.description} arrow placement="right">
                        <span style={{ width: '100%', fontSize: '16px' }}>{option.short_name}</span>
                      </Tooltip>
                    </MenuItem>
                  );
                })}
              </Select>
              {error && (
                <FormHelperText
                  className={classes.helpText}
                  component="div"
                >
                  <ErrorIcon fontSize="small" />
                  <p style={{ margin: 0, padding: 0 }}>
                    This field is required
                  </p>
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <p className={classes.PePrdChoice_text}>Quantity:</p>
            <FormControl variant="outlined" fullWidth>
              <TextField value={qty} type="number" variant="outlined" onChange={handleQtyChange} inputProps={{ min: 1 }}/>
            </FormControl>
          </Grid>
        </Grid>
        {Boolean(peInstall) && <div>
          <Typography variant='h6' 
            align='left' 
            color='secondary' 
            style={{ fontFamily: 'Oswald', fontSize: '20px', marginTop: 10 }}>
            * Installation options:
          </Typography>
          <Divider />
          {(Object.keys(installations).length === 0 || !installations)
            ? <PeMoreInfo label="This option is required. Please click the [Edit unit] button to add it" type='warn'/>
            : <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <p className={classes.PePrdChoice_text}>Type of wall: 
                &nbsp;<b>{renderLabelByValue('brick_type', installations.brick_type)}</b>
              </p>
              <p className={classes.PePrdChoice_text}>Standard installation: 
                &nbsp;<b>{renderLabelByValue('standard_install', installations.standard_install)}</b>
              </p>
              <p className={classes.PePrdChoice_text}>How many stories: 
                &nbsp;<b>{renderLabelByValue('storey_type', installations.storey_type)}</b>
              </p>
              <p className={classes.PePrdChoice_text}>INDOOR located on an EXTERNAL wall: 
                &nbsp;<b>{renderLabelByValue('external_wall', installations.external_wall)}</b>
              </p>
              <p className={classes.PePrdChoice_text}>OUTDOOR location: 
                &nbsp;<b>{renderLabelByValue('outdoor', installations.outdoor)}</b>
              </p>
            </Grid>
            <Grid item xs={12} sm={6}>
              <p className={classes.PePrdChoice_text}>Electrical circuit: 
                &nbsp;<b>{renderLabelByValue('circuit', installations.circuit)}</b>
              </p>
              <p className={classes.PePrdChoice_text}>Existing circuit RCD protected: 
                &nbsp;<b>{renderLabelByValue('rcd', installations.rcd)}</b>
              </p>
              <p className={classes.PePrdChoice_text}>INDOOR vertically inline with OUTDOOR: 
                &nbsp;<b>{renderLabelByValue('vertically', installations.vertically)}</b>
              </p>
              <p className={classes.PePrdChoice_text}>INDOOR on the SAME wall: 
                &nbsp;<b>{renderLabelByValue('same_wall', installations.same_wall)}</b>
              </p>
            </Grid>
          </Grid>}
          {isAuth && <div>
            <Typography variant='h6' 
              align='left' 
              color='secondary' 
              style={{ fontFamily: 'Oswald', fontSize: '20px', marginTop: 10 }}>
              Extra options:
            </Typography>
            <Divider />
            <Grid container spacing={2} style={{ marginBottom: 10 }}>
              <Grid item sm={12}>
                {Object.keys(extras).length > 0 && Object.keys(extras).map((item: any, key: any) => {
                  return Boolean(extras[item].isItemise) 
                    ? <p key={key} className={classes.PePrdChoice_text}>{extras[item].name}:&nbsp;<b>${parseFloat(extras[item].cost)}</b></p>
                    : null
                })}
              </Grid>
            </Grid>
          </div>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            {Boolean(lastItem) && <Button size="small" 
              variant="outlined" 
              color="primary" 
              disableElevation 
              style={{ marginRight: 10 }}
              onClick={handleApplyClick}>
              Use prev Unit's options
            </Button>}
            <Button size="small" variant="outlined" color="primary" disableElevation onClick={handleEditClick}>
              Edit unit
            </Button>
          </div>
        </div>}
      </Paper>
  </Grid>
}

type PeProductChoiceProps = {
  readonly formValues: any,
  readonly label: string,
  readonly required?: boolean,
  readonly id: string,
  readonly meta: {
    touched: any,
    error: any,
    form: any,
  },
  readonly input?: any,
}

const PeProductChoiceRaw: React.FC<PeProductChoiceProps> = ({ label, required, id, formValues, meta, input }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { how_many, pe_installation } = formValues;

  const state = useSelector((state: State) => ({
    productChoice: state.shell.productChoice,
  }));
  const { productChoice } = state;

  const updateItemProd = (num: any, item: any, product: any, qty: any) => {
    let tmpProdChoice = {
      ...productChoice,
      [num]: {
        ...item,
        product: product,
        qty: qty
      }
    };
    dispatch(shellSlice.actions.updateProductChoice(tmpProdChoice));
  }

  const applyPrevUnit = (num: any) => {
    let item = productChoice[parseInt(num) - 1];
    if (Object.keys(item.installations).length === 0) {
      return;
    }
    let tmpProdChoice = {
      ...productChoice,
      [num]: {
        ...productChoice[num],
        installations: item.installations,
        extras: item.extras,
      }
    };
    dispatch(shellSlice.actions.updateProductChoice(tmpProdChoice));
  }

  React.useEffect(()=> {
    if (how_many && how_many > 0) {
      var tmp: any = {};
      Array.from(Array(10)).forEach((item, key) => {
        if (key < how_many) {
          if (productChoice.hasOwnProperty(key + 1)) {
            tmp = {
              ...tmp,
              [key + 1]: productChoice[key + 1]
            };
          } else {
            tmp = {
              ...tmp,
              [key + 1]: defaultItem
            };
          }
        }
      });
      dispatch(shellSlice.actions.updateProductChoice(tmp));
    }
    // eslint-disable-next-line
  }, [how_many]);

  React.useEffect(() => {
    if (pe_installation === 'no' && Object.keys(productChoice).length > 0) {
      let tmpProd = {};
      Object.keys(productChoice).forEach((item: any, key: any) => {
        if (productChoice.hasOwnProperty(item)) {
          tmpProd = {
            ...tmpProd,
            [item]: {
              ...productChoice[item],
              installations: {},
              extras: {},
            }
          }
        }
      });
      dispatch(shellSlice.actions.updateProductChoice(tmpProd));
    }
    // eslint-disable-next-line
  }, [pe_installation]);

  React.useEffect(()=>{
    // set current value to field
    dispatch(change(formName, 'pricing', JSON.stringify(productChoice)));
    // parse to summary choice state
    let summaryChoice: any = {
      mains: {},
      extras: {},
    };
    for (const key in productChoice) {
      // Check daikin main
      const { product, qty, extras } = productChoice[key];

      // Main daikin
      if (summaryChoice.mains.hasOwnProperty(product)) {
        summaryChoice.mains = {
          ...summaryChoice.mains,
          [product]: parseInt(summaryChoice.mains[product]) + parseInt(qty)
        }
      } else {
        summaryChoice.mains = {
          ...summaryChoice.mains,
          [product]: parseInt(qty)
        }
      }

      // Extra
      for (let item in extras) {
        const { isItemise, cost } = extras[item];
        if (summaryChoice.extras.hasOwnProperty(item)) {
          summaryChoice.extras = {
            ...summaryChoice.extras,
            [item]: {
              qty: parseInt(summaryChoice.extras[item].qty) + parseInt(qty),
              itemise: summaryChoice.extras[item].itemise && isItemise,
              cost: Math.max(parseFloat(summaryChoice.extras[item].cost), parseFloat(cost))
            }
          }
        } else {
          summaryChoice.extras = {
            ...summaryChoice.extras,
            [item]: {
              qty: parseInt(qty),
              itemise: isItemise,
              cost: parseFloat(cost)
            }
          }
        }
      }
    }
    dispatch(shellSlice.actions.updateSummaryChoice(summaryChoice));
    // eslint-disable-next-line
  },[productChoice]);

  return <div id={id} className={classes.control}>
    <FormControl error={Boolean(meta?.error)} variant="outlined" fullWidth>
      <input type="hidden" {...input}></input>
      <div className={classes.labelArea}>
        <h3 className={classes.label}>
          {required && <span className={classes.required}>*</span>}&nbsp;{label}
        </h3>
      </div>

      <Grid item container spacing={3}>
        {Object.keys(productChoice).length > 0 && Object.keys(productChoice).map((item: any, key: any) => {
          if (productChoice.hasOwnProperty(item)) {
            return <PeProductItem key={"prod-item-" + key} 
              num={item} 
              item={productChoice[item]} 
              updateItemProd={updateItemProd}
              applyPrevUnit={applyPrevUnit}
              lastItem={Object.keys(productChoice).length > 1 && key > 0 && key <= Object.keys(productChoice).length - 1}
              peInstall={pe_installation === 'yes'}
            />
          }
          return <></>
        })}
      </Grid>

      {meta?.error && <FormHelperText className={classes.helpText} component="div">
        <ErrorIcon fontSize="small" />
        <p style={{ margin: 0, padding: 0 }}>&nbsp;{meta?.error}</p>
      </FormHelperText>}
    </FormControl>
  </div>
}

const PeProductChoice = connect(state => ({
  formValues: getFormValues(formName)(state),
}))(PeProductChoiceRaw);

export default PeProductChoice;